var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { msg, localized } from '@lit/localize';
let ToggleButton = class ToggleButton extends LitElement {
    constructor() {
        super(...arguments);
        this.toggled = false;
        this.labelOn = '';
        this.labelOff = '';
        this.colorOn = '#28a745'; // Couleur pour l'état activé
        this.colorOff = '#dc3545'; // Couleur pour l'état désactivé
    }
    toggleState() {
        this.toggled = !this.toggled;
        this.dispatchEvent(new CustomEvent('toggle-change', {
            detail: { toggled: this.toggled },
            bubbles: true,
            composed: true
        }));
    }
    render() {
        const trackStyle = `background-color: ${this.toggled ? this.colorOn : this.colorOff};`;
        const thumbClass = this.toggled ? 'ggo-switch__thumb--on' : '';
        const label = this.toggled
            ? this.labelOn || msg('On', { id: 'toggle.on', desc: 'Toggle button on-state label' })
            : this.labelOff || msg('Off', { id: 'toggle.off', desc: 'Toggle button off-state label' });
        return html `
      <div class="ggo-switch" @click=${this.toggleState}>
        <div class="ggo-switch__track" style="${trackStyle}">
          <div class="ggo-switch__thumb ${thumbClass}"></div>
        </div>
        <span class="ggo-switch__label">${label}</span>
      </div>
    `;
    }
};
ToggleButton.styles = css `
    .ggo-switch {
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      font-family: inherit;
      font-weight: 700;
      font-size: 10.5px; /* Réduction de 25% */
      user-select: none;
    }

    .ggo-switch__track {
      position: relative;
      width: 37.5px; /* Réduction de 25% */
      height: 18px; /* Réduction de 25% */
      border-radius: 9px; /* Réduction de 25% */
      transition: background-color 0.3s ease;
    }

    .ggo-switch__thumb {
      position: absolute;
      top: 1.5px; /* Réduction de 25% */
      left: 1.5px; /* Réduction de 25% */
      width: 15px; /* Réduction de 25% */
      height: 15px; /* Réduction de 25% */
      background-color: white;
      border-radius: 50%;
      transition: transform 0.3s ease;
      box-shadow: 0 1.5px 3px rgba(0, 0, 0, 0.2); /* Réduction de 25% */
    }

    .ggo-switch__thumb--on {
      transform: translateX(19.5px); /* Réduction de 25% */
    }

    .ggo-switch__label {
      margin-left: 7.5px; /* Réduction de 25% */
      color: #333;
    }
  `;
__decorate([
    property({ type: Boolean })
], ToggleButton.prototype, "toggled", void 0);
__decorate([
    property({ type: String })
], ToggleButton.prototype, "labelOn", void 0);
__decorate([
    property({ type: String })
], ToggleButton.prototype, "labelOff", void 0);
__decorate([
    property({ type: String })
], ToggleButton.prototype, "colorOn", void 0);
__decorate([
    property({ type: String })
], ToggleButton.prototype, "colorOff", void 0);
ToggleButton = __decorate([
    localized(),
    customElement('toggle-button')
], ToggleButton);
export { ToggleButton };
//# sourceMappingURL=ToggleButton.js.map